'use strict';

$(document).ready(function () {

    function decodeUriComponentWithSpace(component) {
        return decodeURIComponent(component.replace(/\+/g, '%20'));
    }

    // type : 'hash', 'search' or 'both'
    function getLocationParameters(location, type) {
        if (type !== 'hash' && type !== 'search' && type !== 'both') {
            throw 'getLocationParameters expect argument 2 "type" to be "hash", "search" or "both"';
        }

        var searchString = typeof location.search === 'undefined' ? '' : location.search.substr(1);
        var hashString = typeof location.hash === 'undefined' ? '' : location.hash.substr(1);
        var queries = [];
        if (type === 'search' || type === 'both') {
            queries = queries.concat(searchString.split('&'));
        }
        if (type === 'hash' || type === 'both') {
            queries = queries.concat(hashString.split('&'));
        }

        var params = {};
        var pair = void 0;

        for (var i = 0; i < queries.length; i++) {
            if (queries[i] !== '') {
                pair = queries[i].split('=');
                params[decodeUriComponentWithSpace(pair[0])] = decodeUriComponentWithSpace(pair[1]);
            }
        }

        return params;
    }

    $('#submitComment').click(function (event) {
        event.preventDefault();

        var urlParams = getLocationParameters(window.location, 'both');
        var feedbackObject = { 'id': urlParams['RATINGS-LOAN-NUMBER'] || 'No loan number specified', 'feedback': $('#feedback').val() };

        axios.post(globalSiteSettings.feedbackApiUrl + '/save_feedback', feedbackObject).then(function (response) {
            if (response.data.sent) {
                $('#feedback-error').attr('style', 'display: none;');
                window.location.href = '/feedback-confirmation/';
            } else {
                $('#feedback-error').attr('style', 'display: block;');
                window.debugLog('There was an error with sending/saving this response.\nResponse:', response.data);
            }
        }).catch(function (error) {
            $('#feedback-error').attr('style', 'display: block;');
            window.debugLog('Error:', error);
        });
    });
});